import SearchService from '../../classes/SearchService';
import { DEFAULT_BIKE_COLOR } from '../../constants/bike';
import { UNITS } from '../../constants/units';
import getExternalLink from '../../functions/getExternalLink';

const searchService = new SearchService();

const minBikeHeight = searchService.getHeightRange().min;

const BikeReducer = (
    state =
        {
            bike: {},
            rangeValue: minBikeHeight,
            color: DEFAULT_BIKE_COLOR,
            willLast: 0,
            unit: UNITS.inches,
            link: getExternalLink(),
            nextBike: '',
            bikeDueDate: '',
            estimatedHeight: 0
        }, action) => {
    switch (action.type) {
        case 'SET_BIKE':
            return {
                ...state,
                bike: action.bike
            };
        case 'SET_FINAL_BIKE':
            return {
                ...state,
                bike: action.bike
            };
        case 'SET_NEXT_BIKE':
            return {
                ...state,
                nextBike: action.nextBike
            };
        case 'SET_VALUE':
            return {
                ...state,
                rangeValue: action.rangeValue
            };
        case 'SET_COLOR':
            return {
                ...state,
                color: action.color
            };
        case 'SET_BIKE_WILL_LAST':
            return {
                ...state,
                willLast: action.willLast
            };
        case 'SET_BIKE_DUE_DATE':
            return {
                ...state,
                bikeDueDate: action.bikeDueDate
            };
        case 'SET_ESTIMATED_HEIGHT':
            return {
                ...state,
                estimatedHeight: action.estimatedHeight
            };
        case 'SET_UNIT':
            return {
                ...state,
                unit: action.unit
            };
        case 'SET_LINK':
            return {
                ...state,
                link: action.link
            };            
        default:
            return state;
    }
};

export default BikeReducer;


// WEBPACK FOOTER //
// ./src/redux/reducers/BikeReducer.js